/**
 * 页首页尾导航锚点跳转：直接定位到对应模块的顶部（无平滑滚动动画）。
 */
export function lovemoScrollToSection(sectionId: string) {
  const el = document.getElementById(sectionId);
  if (!el) return;
  const headerOffset = 82;
  const top = el.getBoundingClientRect().top + window.scrollY - headerOffset;
  window.scrollTo({ top: top < 0 ? 0 : top, behavior: 'auto' });
}